export default "4d85dc56342d1336.svg"